import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import Input from "./../common/inputfunction";
import Renderaccount from "./rederaccountlist";
import ModalAccount from "./adduser";
import Modaladduser from "./modaladduser";
import { getAccountlist } from "./../../services/fire";
import BranchContext from "./../../components/context/branch";
import ScrollToTop from "../common/ScrollToTop";
import FontAwesome from "react-fontawesome";

const AccountList = () => {
  const [name, setname] = useState("");
  const [accountlist, setaccountlist] = useState([]);
  const [total, settotal] = useState(0);
  const [search, setsearch] = useState("");
  const [buid, setbuid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [lastupdate, setlastupdate] = useState(new Date());
  const { currentBranch } = useContext(BranchContext);
  const [showonscroll, setshowonscroll] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [isOpenuser, setisOpenuser] = useState(false);
  const [data, setdata] = useState([]);
  const [values, setvalues] = useState({ id: 0, name: "" });
  const [header, setheader] = useState("เพิ่มผู้ใช้งาน");
  const [refresh, setRefresh] = useState(new Date());

  useEffect(() => {
    setaccountlist([]);
  }, [currentBranch, pageSize, search, buid, refresh]);

  useEffect(() => {
    if (!currentBranch) return;

    if (!pageSize || !pageNumber) return;
    setLoading(true);
    setError(false);

    const loadData = async () => {
      const { data: result } = await getAccountlist(
        search,
        buid,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        settotal(result.data.total);
       
        setaccountlist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [currentBranch, search, pageSize, pageNumber, buid, refresh]);
  //console.log("accountlist",accountlist)

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleChange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleSearchClick = () => {
    setPageNumber(1);

    setsearch(name);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setPageNumber(1);
      setsearch(name);
    }
  };
  const handleonClick = (id, status) => {
   
    setvalues({ id: id, name: status });
    setdata([]);

    const subdata = accountlist.filter((x) => x.empid === id);
    setheader("แก้ไขผู้ใช้งาน");
    setdata(subdata);
    setisOpen(true);


  };

  const handleAddOnClick = (id, status) => {
    setvalues({ id: id, name: status });
    //  console.log(id,status);
    setdata([]);
    // const subdata = (devicelist.filter(x=> x._id ===id))
    setheader("เพิ่มผู้ใช้");

    setisOpenuser(true);
  };

  const handleCancleSubmit = () => {

    setisOpen(false);
    setisOpenuser(false);
  };
 
  const handleCancleuser = () => {
    setisOpenuser(false);
    
  };
  const Restatus = () => {
    setRefresh(new Date())
    // setrestatus(0+ 1);
  
  };
  const handleConfirmSubmit = () => {
    setlastupdate(new Date());
    setisOpen(false);
  };
  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };

  return (
    <>
    <Modaladduser
    isOpen={isOpenuser}
    onCancel={handleCancleuser}
   
    />

      <ModalAccount
        isOpen={isOpen}
        button1="บันทึก"
        onCancel={handleCancleSubmit}
        onChange={handleTextchange}
        onconfirm={handleConfirmSubmit}
        enable={true}
        list={data}
        value={values}
        header={header}
        restatus ={Restatus}
      />

      <div className="row">
        <div className="col-lg-4  col-sm-10 col-xs-12">
          <div className="form-group">
            <Input
              name="name"
              value={name}
              label="ชื่อ"
              placeholder="ระบุชื่อเพื่อค้นหา"
              onChange={handleChange}
              onClick={handleSearchClick}
              onKeyPress={handleKeyPress}
              search="ค้นหา"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-auto mt-2">
          <div className="container">
            <button
              className="btn btn-primary"
              onClick={() => handleAddOnClick(0, "new")}
            >
              <FontAwesome name="plus" />
              <i /> Add New
            </button>
            <br />
            <br />
          </div>
        </div>
        <div className="col-auto mt-2">
          <p className="text-success">
            แสดงข้อมูล {accountlist ? accountlist.length : 0} / {total} รายการ
          </p>
        </div>
      </div>

      <ScrollToTop onClick={scrollToTop} />

      <Renderaccount
        list={accountlist}
        handleOnClick={handleonClick}
        error={error}
        lastBookElementRef={lastBookElementRef}
        // handleChangeToggle={handleChangeToggle}
      />
    </>
  );
};

export default AccountList;
